<header class="header grid grid-cols-2 mt-1 mb-3 mx-7 h-6">
  <div class="logo w-28 flex items-center">
    <img src="assets/img/logo_cangas_aventura.png" routerLink="/panel/dashboard" alt="logo Cangas Aventura">
  </div>
  <div class="data-user flex flex-row items-center justify-end gap-1">
    <app-serial-connections></app-serial-connections>
    <ng-container *ngIf="profile !== null">
      <h4>{{profile.name}}</h4>
      <button (click)="onLogoutClick()">
        <img src="assets/icons/icon_logout.png" alt="logo logout">
      </button>
    </ng-container>
  </div>
</header>
